module.exports = __webpack_public_path__ + "static/media/empty.72887eda.png";